<template>
<div class="show_on_mobile">
<Sidebar v-model:visible="$store.state.ui.notifications" position="right">
<h2	class="logo text-primary ml-2 pt-2 pb-4" >VERIFY</h2>
<Divider class="mt-0 mb-4"/>
<leftSidebarItem v-for="item in menuitems" :key="item.key" :data="item"></leftSidebarItem>

</Sidebar>
</div>
</template>

<script>
import leftSidebarItem from  "./leftSidebarItem"
export default {

  name: 'Notifications',
  components:{
  	leftSidebarItem
  },
  data () {
    return {
    	menuitems:[
    	{
    		key:"dashboard",
    		title:"Dashboard",
    		link:"/"+this.$store.state.auth.user.uuid+"/dashboard",
    		capital:"D",
    		color:"#ea2c54",
    	},
    	{
    		key:"brands",
    		title:"Markalar",
    		link:"/"+this.$store.state.auth.user.uuid+"/brands",
    		capital:"B",
    		color:"#4d4d4d",
    	},
    	{
    		key:"suppliers",
    		title:"Tedarikçiler",
    		link:"/"+this.$store.state.auth.user.uuid+"/suppliers",
    		capital:"S",
    		color:"#4d4d4d",
    	},
    	{
    		key:"users",
    		title:"Kullanıcılar",
    		link:"/"+this.$store.state.auth.user.uuid+"/users",
    		capital:"K",
    		color:"#4d4d4d",
    	}

    	]
    }
  }
}
</script>

<style lang="css" scoped>
</style>